export const GA_MEASUREMENT_ID = "G-339J21TNLN"

let readyResolve
const ready = new Promise((res) => (readyResolve = res))
let initialized = false

const pendingEvents = []

function loadGtagOnce() {
  if (typeof window === "undefined") return
  if (!GA_MEASUREMENT_ID) return
  if (document.getElementById("ga4-tag")) return

  const s = document.createElement("script")
  s.async = true
  s.id = "ga4-tag"
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  s.onload = () => {
    pendingEvents
      .splice(0)
      .forEach(([name, params]) => window.gtag("event", name, params))
    readyResolve()
  }
  document.head.appendChild(s)
}

export function initAnalytics() {
  if (typeof window === "undefined") return
  if (!GA_MEASUREMENT_ID) return
  if (initialized) return

  initialized = true
  loadGtagOnce()

  window.dataLayer = window.dataLayer || []
  window.gtag =
    window.gtag ||
    function gtagShim() {
      const args = Array.from(arguments)
      if (args[0] === "event") {
        pendingEvents.push([args[1], args[2]])
      } else {
        window.dataLayer.push(args)
      }
    }

  window.gtag("js", new Date())
  window.gtag("config", GA_MEASUREMENT_ID, {
    send_page_view: false,
    debug_mode: false,
  })
}

export function whenAnalyticsReady() {
  return ready
}

export function trackPageView(path, title) {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID) return
  ;(window.gtag || (() => {}))("event", "page_view", {
    page_location: window.location.origin + path,
    page_path: path,
    page_title: title || document.title,
  })
}

export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || !GA_MEASUREMENT_ID) return
  ;(window.gtag || (() => {}))("event", name, params)
}
